/*
  GOPSHOP 7.1 – Schnell in den Warenkorb (snippets/gop-quick-add.liquid)
  Formular [data-gop-qa] → /cart/add.js (JSON), danach Dawn-Warenkorb (Schublade/Hinweis) mit den
  zurückgelieferten Sections öffnen – genau wie Dawns Produktformular. Fehler (z. B. ausverkauft) als Text
  unter dem Knopf. Ohne JS sendet das Formular normal an /cart/add (→ Warenkorb-Seite).
*/
(function () {
  if (window.__gopQA) return;
  window.__gopQA = true;

  function cartEl() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function msg(form, text, bad) {
    var m = form.querySelector('[data-gop-qa-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.classList.toggle('is-bad', !!bad);
  }

  function busy(btn, on) {
    btn.classList.toggle('is-busy', on);
    btn.setAttribute('aria-disabled', on ? 'true' : 'false');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-gop-qa]')) return;
    if (!window.fetch) return; /* alter Browser → normales Absenden */
    e.preventDefault();
    var btn = form.querySelector('.gqa__btn');
    if (!btn || btn.disabled || btn.classList.contains('is-busy')) return;
    /* Radio, Auswahlliste oder verstecktes Feld – FormData liefert jeweils den gewählten Wert */
    var id = parseInt(new FormData(form).get('id'), 10) || 0;
    if (!id) return;
    var cart = cartEl();
    var body = { items: [{ id: id, quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
    }
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    msg(form, '');
    busy(btn, true);
    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(
          function (d) {
            return { ok: r.ok, d: d };
          },
          function () {
            return { ok: r.ok, d: {} };
          }
        );
      })
      .then(function (res) {
        var d = res.d || {};
        busy(btn, false);
        if (!res.ok || d.status) {
          var t = d.description || d.message;
          /* Shopify-Text (z. B. „… ist bereits ausverkauft“) zeigen; technische Meldungen → eigener klarer Text */
          var ok = typeof t === 'string' && t && !/cannot find variant|parameter missing|invalid/i.test(t);
          msg(form, ok ? t : form.getAttribute('data-err'), true);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, { source: 'gop-quick-add', productVariantId: id, errors: d.errors || d.description, message: d.message });
          }
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gop-quick-add', productVariantId: id, cartData: d });
        }
        var items = Array.isArray(d.items) ? d.items : [];
        var line = items[0] || {};
        if (cart && d.sections && typeof cart.renderContents === 'function') {
          try {
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
            cart.renderContents(Object.assign({}, line, { sections: d.sections }));
            cart.classList.remove('is-empty');
            return;
          } catch (err) {
            /* weiter unten: Hinweis + Link */
          }
        }
        msg(form, form.getAttribute('data-done'));
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function () {
        busy(btn, false);
        msg(form, form.getAttribute('data-err'), true);
      });
  });
})();
